'use client';

import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';

export const RESULTS_HREF = '/v2/results';

export function BackButton() {
  return (
    <Link href={RESULTS_HREF} className="inline-flex items-center gap-1 text-lg font-bold text-primary-brand">
      <ChevronLeft className="size-5" />
      Back
    </Link>
  );
}
